import React, { useEffect } from 'react';
import { CheckCircle, AlertCircle, Info, X } from 'lucide-react';

export type ToastType = 'success' | 'error' | 'info';

interface ToastProps {
    message: string;
    type: ToastType;
    onClose: () => void;
}

const Toast: React.FC<ToastProps> = ({ message, type, onClose }) => {
    useEffect(() => {
        const timer = setTimeout(() => {
            onClose();
        }, 4000);
        return () => clearTimeout(timer);
    }, [onClose]);

    const config = {
        success: {
            icon: <CheckCircle className="text-green-500" size={20} />,
            bg: 'bg-green-50',
            border: 'border-green-100',
            text: 'text-green-800'
        },
        error: {
            icon: <AlertCircle className="text-red-500" size={20} />,
            bg: 'bg-red-50',
            border: 'border-red-100',
            text: 'text-red-800'
        },
        info: {
            icon: <Info className="text-blue-500" size={20} />,
            bg: 'bg-blue-50',
            border: 'border-blue-100',
            text: 'text-blue-800'
        }
    };

    const { icon, bg, border, text } = config[type];

    return (
        <div className={`fixed bottom-24 left-1/2 -translate-x-1/2 z-[100] flex items-center gap-3 px-4 py-3 rounded-2xl shadow-xl border ${bg} ${border} ${text} animate-slide-up max-w-[90vw] md:max-w-md w-full sm:w-auto`}>
            <div className="shrink-0">{icon}</div>
            <p className="text-sm font-bold flex-1 leading-tight">{message}</p>
            <button onClick={onClose} className="p-1 hover:bg-black/5 rounded-full transition-colors">
                <X size={16} />
            </button>
        </div>
    );
};

export default Toast;
